module.exports = __webpack_public_path__ + "static/media/icon_profile_1600x1600.7fd43c8e.png";